import { isFirefoxBrowser, prefersVideoStreamPlayback } from './videoPlaybackMode';

/** Mobile browsers (Firefox/Chrome Android) often reject blob URLs from ArrayBuffer; XHR refetch fixes it. */
function refetchBlobUrl(blobUrl: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', blobUrl, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200 && xhr.response instanceof Blob && xhr.response.size > 0) {
        resolve(URL.createObjectURL(xhr.response));
      } else {
        reject(new Error(`blob refetch HTTP ${xhr.status}`));
      }
    };
    xhr.onerror = () => reject(new Error('blob refetch network error'));
    xhr.send();
  });
}

/**
 * Create an object URL that plays on mobile browsers (optional XHR refetch on touch devices).
 */
export async function androidSafeObjectUrl(
  data: Blob | Uint8Array,
  mime: string,
  filename = 'clip.mp4'
): Promise<string> {
  if (isFirefoxBrowser()) {
    const file =
      data instanceof File
        ? data
        : new File([data instanceof Blob ? data : new Uint8Array(data)], filename, { type: mime });
    return URL.createObjectURL(file);
  }

  const blob =
    data instanceof Blob
      ? data
      : new Blob([new Uint8Array(data)], { type: mime });

  if (!prefersVideoStreamPlayback()) {
    return URL.createObjectURL(blob);
  }

  const first = URL.createObjectURL(blob);
  try {
    const second = await refetchBlobUrl(first);
    URL.revokeObjectURL(first);
    return second;
  } catch {
    return first;
  }
}
